import { GestureNativeEvent } from 'types';

export const isTargetElement = (e: GestureNativeEvent) => e.target
  && e.target.parentElement
  && e.target.parentElement.classList
  && e.target.parentElement.classList.contains('element');
